export enum RootCategories {
    US = '100',
    CA = '200',
}
